module.exports = "/packs/_/assets/images/flags/flag-uk-54b361183482451aa75d0a0c0c030db9.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/flags/flag-uk.svg
// module id = 1771
// module chunks = 0